export enum Position {
  Top = 'top',
  Center = 'center',
  Bottom = 'bottom',
}

export enum Direction {
  Next = 'next',
  Prev = 'prev',
}

export enum ProfileAction {
  Logout = 'logout',
  Delete = 'delete',
  switchProfile = 'switchProfile',
}

export enum Platform {
  Ios = 'ios',
  Android = 'android',
}
export enum TrainingStatus {
  InProgress = 'In Progress',
  CourseCompleted = 'Level Completed',
  Completed = 'Completed',
  Locked = 'Locked',
}
export enum LevelAssessmentType {
  GrandQuiz = 'grand_quiz',
  DiagnosticQuiz = 'diagnostic',
}
export enum LevelCardPrimaryButtonText {
  StartTrainings = 'Start Trainings',
  ContinueTrainings = 'Continue Trainings',
}
